module.exports = __webpack_public_path__ + "img/10551388_L.48f98abe.png";